import { useUnit } from 'effector-react';
import { $branding, $bootstrapPending, $isAuthenticated, $tenantConfig } from '@buildex/core';
import { TenantThemeProvider } from '@buildex/theme';
import { FullscreenLoader } from '@buildex/ui';
import { $manifests } from './modules/model';
import { CabinetRouter } from './router';
import { LoginPage } from '@/pages/login/LoginPage';

function AppContent() {
  const { pending, isAuthenticated, config, manifests } = useUnit({
    pending: $bootstrapPending,
    isAuthenticated: $isAuthenticated,
    config: $tenantConfig,
    manifests: $manifests,
  });

  if (pending) return <FullscreenLoader />;
  if (!isAuthenticated) return <LoginPage />;
  if (config === null || manifests === null) return <FullscreenLoader />;

  return <CabinetRouter manifests={manifests} />;
}

export function App() {
  return (
    <TenantThemeProvider branding={$branding}>
      <AppContent />
    </TenantThemeProvider>
  );
}
